<template>
	<div id="filespecifications">
		<div>
			<div class="row">
				<div class="col-12">
					<el-select v-model="SpecType" placeholder="Select" class="topDropdown"  @change="getFileSpecifications()" default-first-option filterable>
						<el-option
								v-for="item in SpecTypes"
								:label="item"
								:value="item"
								:key="item">
						</el-option>
					</el-select>
				</div>
			</div>
            <div class="row mt-4" v-if="showRecords">
				<div class="col-12">
					<h5>Records&nbsp;<el-button @click.prevent="addNewEntry()" size="small" type="success">Add</el-button></h5>
					<table class="table table-striped">
						<thead>
						<tr>
							<th scope="col"><div class="heading Value">Code</div><div class="heading Name">Name</div><div class="heading Sort">Order</div></th>
							<th scope="col">Remove</th>
						</tr>
						</thead>
						<tbody>
                            <template v-for="(item, index) in filespecifications">
                                <tr  v-if="item.operation != 'delete'">
                                    <td>
                                        <el-input v-model="item.SpecValue" @change="updateEntry(index)" class="Value" style="margin-right: 10px;"></el-input>
                                        <el-input v-model="item.SpecName" @change="updateEntry(index)" class="Name" style="margin-right: 10px;"></el-input>
                                        <el-input v-model="item.SortOrder" @change="updateEntry(index)" class="Sort" style="margin-right: 10px;"></el-input>
                                    </td>
                                    <td align=center>
                                        <a href="#" class="delete" @click.prevent="deleteEntry(index)"><i class="fas fa-trash"></i></a>
                                    </td>
                                </tr>
                            </template>
						</tbody>
					</table>
				</div>
	        </div>
		</div>
		<div class="row" v-if="(modifyAccess || createAccess) && filespecifications.length > 0" >
            <div class="col-12 text-center">
                <button class="btn btn-success btn-icon" @click="save" style="margin-right: 10px;">
                    <i class="fas fa-check"></i> <span> Save Changes</span>
                </button>
                <button class="btn btn-icon btn-dark cancel"  @click="reset(true)">
                    <i class="fas fa-times"></i>  <span>Cancel</span>
                </button>
            </div>
        </div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import axios from 'axios';
    import Util from '../assets/js/util.js';

	const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;
	export default {
		data () {
			return {
				SpecTypes: ['BPM', 'Format', 'Genre', 'Length', 'Mood'],
				SpecType: '',
				filespecifications : [],
				showRecords: false,
			}
		},
		name: 'FileSpecifications',
		props:["config"],
		computed: {
			...mapGetters({ currentUser: 'currentUser' }),
			...mapGetters({ componentIDs: 'componentIDs' }),
			isInitial() {
				return this.currentStatus === STATUS_INITIAL;
			},
			isSaving() {
				return this.currentStatus === STATUS_SAVING;
			},
			isSuccess() {
				return this.currentStatus === STATUS_SUCCESS;
			},
			isFailed() {
				return this.currentStatus === STATUS_FAILED;
			},
	        createAccess () {
                return Util.createAccess(this.currentUser);
            },
	        modifyAccess () {
                return Util.modifyAccess(this.currentUser);
            },
		},
		methods: {
			addNewEntry() {
				this.filespecifications.unshift(
					{
						FileSpecificationID: '',
						SpecType: this.SpecType,
						SpecValue: '',
						SpecName: '',
						SortOrder: '',
						operation: 'add'
					}
				);
			},
			deleteEntry(idx) {
				if (this.filespecifications[idx].FileSpecificationID != '') {
					this.filespecifications[idx]['operation'] = 'delete';
				} else {
					this.filespecifications.splice(idx, 1);
				}
			},
			updateEntry(idx) {
				this.filespecifications[idx].operation = 'update';
			},
			reset(showMessage) {
				// reset form to initial state
				this.currentStatus = STATUS_INITIAL;
				if (!showMessage) {
					if (this.componentIDs.SpecType) {
						this.SpecType = this.componentIDs.SpecType;
					}
				}
				if (this.SpecType) {
					this.getFileSpecifications();
				}

				if (showMessage) {
					this.$notify({
						title: 'Success',
						message: 'Data has been reset',
						type: 'success',
						duration: 1500,
						showClose: false
					});
                 }
			},
			getFileSpecifications () {
				let self = this;
				if (this.SpecType == ''){
					this.SpecType = this.SpecTypes[0];
				}
				axios.post('/filespecifications/get', {SpecType: this.SpecType},
				)
				.then(response => {
					if (response.data.result == 'success') {
						self.$store.dispatch('setID', {'SpecType': self.SpecType});

						this.filespecifications = (response.data.filespecifications ? response.data.filespecifications : [])
						this.showRecords = true;
					} else {
					}
				}).catch(response => {
				});

			},
			save () {
				if (this.isValid()) {
					if (!this.isDuplicate ()) {
						if (this.currentStatus == STATUS_SAVING) {
							return true;
						}
						this.currentStatus = STATUS_SAVING;

						axios.post('/filespecifications/save', {SpecType: this.SpecType, filespecifications: this.filespecifications}
						)
						.then(response => {
							if (response.data.result == 'success') {
								this.currentStatus = STATUS_INITIAL;

								this.$notify({
									title: 'Success',
									message: 'File Specifications have been saved',
									type: 'success',
									duration: 1500,
									showClose: false
								});
								this.getFileSpecifications();
							} else {
								this.currentStatus = STATUS_FAILED;
								this.displayPopup (response.data.message);
							}
						}).catch(response => {
							this.currentStatus = STATUS_FAILED;
						});
					} else {
						this.displayPopup ('Duplicate names exist, please change or delete');
					}
				} else {
					this.displayPopup ('Code and Name are required');
				}
			},
			isDuplicate () {
				let nameArray = [];
				let valueArray = [];
				for (let i = 0; i < this.filespecifications.length; i++) {
					if ((this.filespecifications[i].operation && this.filespecifications[i].operation != 'delete') || !this.filespecifications[i].operation) {
						if (nameArray.indexOf(this.filespecifications[i].SpecName) != -1 || valueArray.indexOf(this.filespecifications[i].SpecValue) != -1) {
							return true;
						} else {
							nameArray.push(this.filespecifications[i].SpecName);
							valueArray.push(this.filespecifications[i].SpecValue);
						}
					}
				}
				return false;
			},
			isValid () {
				for (let i = 0; i < this.filespecifications.length; i++) {
					if ((this.filespecifications[i].operation && this.filespecifications[i].operation != 'delete')) {
						if (this.filespecifications[i].SpecValue == '' || this.filespecifications[i].SpecName == '') {
							return false;
						}
					}
				}
				return true;
			},

	        displayPopup (message) {
				this.$alert(message,  {
					type: 'error',
					confirmButtonText: 'OK',
				});
	        }
		},
		mounted() {
			this.reset(false);
		},
	}
</script>

<style scoped>

	.el-select {
		width: 50%;
	}
	.country.el-select {
		width: 100%;
	}
	table thead tr th:last-child {
		text-align: center;
	}
	.id {
		padding-top: 6px;
	}
	.delete{
		padding-top: 10px;
	}
	.el-input.Value, .el-input.Name {
		width: 40%;
		margin-bottom: 5px;
	}
	.el-input.Sort {
		width: 10%;
		margin-bottom: 5px;
		text-align:center;
	}
	.heading.Value, .heading.Name {
		width: 40%;
		margin-bottom: 5px;
		text-align: center;
		display: inline-block;
	}
	.heading.Sort {
		width: 10%;
		margin-bottom: 5px;
		text-align: center;
		display: inline-block;
	}

</style>
